import { render, staticRenderFns } from "./AccessManager.vue?vue&type=template&id=5d1efb67"
import script from "./AccessManager.vue?vue&type=script&lang=js"
export * from "./AccessManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports